import { createContext, useContext, type Context } from 'react';

import { type ActionContext } from '@atlassian/conversation-assistant-message-actions-api/types';

import type { Build, PlanState } from '../../types';

export const SolutionPlanContext: Context<{
	builds: Build[];
	currentBuildNumber: number;
	refetchSolutionPlan: () => void;
	cloudId: string;
	aaid?: string;
	spaceId?: string;
	workspaceId?: string; // TODO Remove optional when cleaning fe_enable_sa_externally
	renderingTouchpoint?: ActionContext['renderingTouchpoint'];
	solutionState: PlanState;
}> = createContext<{
	builds: Build[];
	currentBuildNumber: number;
	refetchSolutionPlan: () => void;
	cloudId: string;
	aaid?: string;
	spaceId?: string;
	workspaceId?: string; // TODO Remove optional when cleaning fe_enable_sa_externally
	renderingTouchpoint?: ActionContext['renderingTouchpoint'];
	solutionState: PlanState;
}>({
	builds: [],
	currentBuildNumber: 0,
	refetchSolutionPlan: () => {},
	cloudId: '',
	aaid: '',
	spaceId: '',
	workspaceId: '',
	solutionState: 'DRAFT',
});

export const useSolutionPlan = (): {
	builds: Build[];
	currentBuildNumber: number;
	refetchSolutionPlan: () => void;
	cloudId: string;
	aaid?: string;
	spaceId?: string;
	workspaceId?: string; // TODO Remove optional when cleaning fe_enable_sa_externally
	renderingTouchpoint?: ActionContext['renderingTouchpoint'];
	solutionState: PlanState;
} => {
	const solutionPlanContext = useContext(SolutionPlanContext);
	if (!solutionPlanContext) {
		throw new Error('useSolutionPlan must be used within a SolutionPlanContext');
	}
	return solutionPlanContext;
};
